// extracted by mini-css-extract-plugin
export default {"timer":"cjE0ONZ5R3P2A8b_PhKV","separator":"socxbn95SuO14IL19ooe"};